var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value":_vm.value,"picker-options":_setup.pickerOptions},on:{"input":_setup.handleInput,"change":_setup.handleChange,"blur":_setup.resetPickedDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }